// TODO: make this based on the version/build number
export const cacheBust = 1;


// WEBPACK FOOTER //
// ./src/util/cacheBust.ts